import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { getApiUrl } from '../../config/api';
import {
  FaChartLine,
  FaUsers,
  FaHome,
  FaCalendarCheck,
  FaRupeeSign,
  FaStar,
  FaFileAlt,
  FaExclamationTriangle,
  FaBars,
  FaTimes,
  FaSignOutAlt,
} from 'react-icons/fa';
import './AdminLayout.css';

const AdminLayout = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const u = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (!u || !token) {
      navigate('/login');
      return;
    }
    try {
      const parsed = JSON.parse(u);
      if (parsed.role !== 'admin') {
        navigate('/');
        return;
      }
      setUser(parsed);
    } catch {
      navigate('/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/');
  };

  if (!user) {
    return (
      <div className="admin-layout-loading">
        <div className="admin-spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  const navItems = [
    { to: '/admin', end: true, icon: FaChartLine, label: 'Dashboard' },
    { to: '/admin/users', end: false, icon: FaUsers, label: 'User Overview' },
    { to: '/admin/properties', end: true, icon: FaHome, label: 'Property Overview' },
    { to: '/admin/bookings', end: true, icon: FaCalendarCheck, label: 'Booking Monitoring' },
    { to: '/admin/payments', end: true, icon: FaRupeeSign, label: 'Payments & Commission' },
    { to: '/admin/reviews', end: true, icon: FaStar, label: 'Reviews & Feedback' },
    { to: '/admin/reports', end: true, icon: FaFileAlt, label: 'Reports & Analytics' },
    { to: '/admin/logs', end: true, icon: FaExclamationTriangle, label: 'Error & System Logs' },
  ];

  return (
    <div className="admin-layout">
      <header className="admin-header">
        <button type="button" className="admin-menu-toggle" onClick={() => setSidebarOpen((o) => !o)} aria-label="Menu">
          {sidebarOpen ? <FaTimes /> : <FaBars />}
        </button>
        <h1 className="admin-header-title">Admin Panel</h1>
        <div className="admin-header-user">
          <span>{user.name || user.email}</span>
          <button type="button" className="admin-logout-btn" onClick={handleLogout}>
            <FaSignOutAlt /> Logout
          </button>
        </div>
      </header>

      <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
        <nav className="admin-nav">
          {navItems.map(({ to, end, icon: Icon, label }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}
            >
              <Icon />
              <span>{label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      <main className="admin-main">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
